import { BadgeImageModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class BadgeImageService extends ApiService<BadgeImageModel> {
	constructor() {
		super('badgeimage');
	}
}

export default new BadgeImageService();
